import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as moment from 'moment';
import { Subject, throwError } from 'rxjs';
import { catchError, map, publishReplay, refCount } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class User180TurnService {
  error = new Subject<string>();
  slug = '/user_180_turns';
  resourceName = 'user_180_turns';
  all180Turns?: any;
  user180_turnsBetween?: any;

  constructor(private http: HttpClient) {}

  fetchAll(): any {
    if (!this.all180Turns) {
      this.all180Turns = this.http
        .get<any>(environment.apiUrl + this.slug, {
          responseType: 'json',
        })
        .pipe(
          map((responseData) => {
            const returnArray: any[] = [];
            responseData['_embedded'][this.resourceName].forEach(
              (item: any) => {
                returnArray.push(item);
              }
            );
            return returnArray;
          }),
          catchError((errorRes) => {
            return throwError(errorRes);
          }),
          publishReplay(1),
          refCount()
        );
    }

    return this.all180Turns;
  }

  clearCache() {
    this.all180Turns = null;
    this.user180_turnsBetween = null;
  }

  fetch(id: number) {
    return this.http
      .get<any>(environment.apiUrl + this.slug + '/' + id, {
        responseType: 'json',
      })
      .pipe(
        map((responseData) => {
          return responseData;
        }),
        catchError((errorRes) => {
          return throwError(errorRes);
        })
      );
  }

  create(steps: string, date_recorded: string) {
    this.clearCache();
    const payload = {
      date_recorded: moment(date_recorded).format('YYYY-MM-DD'),
      steps,
    };
    return this.http.post<any>(environment.apiUrl + this.slug, payload, {
      observe: 'response',
    });
  }

  update(id: number, steps: string, date_recorded: string) {
    this.clearCache();
    const payload = {
      date_recorded: moment(date_recorded).format('YYYY-MM-DD'),
      steps,
    };
    return this.http.patch<any>(
      environment.apiUrl + this.slug + '/' + id,
      payload,
      {
        observe: 'response',
      }
    );
  }

  delete(id: number) {
    this.clearCache();
    return this.http.delete<{ name: string }>(
      environment.apiUrl + this.slug + '/' + id
    );
  }

  getRag(steps) {
    let ragColour = '';

    if (+steps <4) {
      ragColour = 'green';
    } else {
      ragColour = 'red';
    }

    return ragColour;
  }

  getRangeforColor(colour: string) {
    let ragRange = '';
    if (colour == 'green') {
      ragRange = '<4';
    } else if (colour == 'amber') {
      ragRange = '';
    } else {
      ragRange = '≥4';
    }

    return ragRange;
  }
}
